const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const OTP_REGEX = /^[A-Za-z0-9]{6}$/;

export const validateLoginEmail = (email) => {
	if (!email) return "login.error-email-required";
	if (!EMAIL_REGEX.test(email)) return "login.error-invalid-email";
	return null;
};

export const validateLoginCode = (code) => {
	if (!code || code.length < 6) return "login.error-code-required";
	if (!OTP_REGEX.test(code)) return "login.error-code-invalid";
	return null;
};
